var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogostric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.901,
    height: 24,
    viewBox: "0 0 62.901 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65595",
    "data-name": "Grupo 65595",
    transform: "translate(-168 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M71.059,480.937a9.278,9.278,0,0,1-4.151-1.151,6.283,6.283,0,0,1-1.9-1.689,1.4,1.4,0,0,1,.1-1.891,1.388,1.388,0,0,1,1.994-.054,9.523,9.523,0,0,0,1.97,1.571,5.454,5.454,0,0,0,4.41.369,1.9,1.9,0,0,0,1.309-2.423,1.838,1.838,0,0,0-1.086-1.2c-.631-.285-1.292-.509-1.948-.732-1.156-.393-2.339-.716-3.474-1.162a4.339,4.339,0,0,1-2.515-2.32A4.408,4.408,0,0,1,66.82,465.2a6.69,6.69,0,0,1,5.033-1.634,7.733,7.733,0,0,1,4.167,1.4,5.871,5.871,0,0,1,.926.855,1.332,1.332,0,0,1-.059,1.964,1.432,1.432,0,0,1-2.033-.18,4.692,4.692,0,0,0-4.433-1.348,3.216,3.216,0,0,0-1.272.508,1.805,1.805,0,0,0-.112,2.8,5.123,5.123,0,0,0,1.514.82c1.162.4,2.362.7,3.53,1.094a5.43,5.43,0,0,1,3.033,2.152,4.331,4.331,0,0,1,.62,2.656c-.121,2.149-1.466,3.349-3.305,4.133A7.847,7.847,0,0,1,71.059,480.937Z",
    transform: "translate(103.313 -424.967)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M830.363,472.059a8.814,8.814,0,0,1,2.221-6.182,7.736,7.736,0,0,1,5.209-2.556,10.879,10.879,0,0,1,4.409.463,3.772,3.772,0,0,1,2.129,1.444,1.6,1.6,0,0,1,.242,1.239,1.336,1.336,0,0,1-2.106.93,6.722,6.722,0,0,1-.744-.533,4.414,4.414,0,0,0-2.469-.661,5.276,5.276,0,0,0-3.273.872,5.379,5.379,0,0,0-2.332,3.746,6.286,6.286,0,0,0,.838,4.543,4.948,4.948,0,0,0,3.953,2.395,5.661,5.661,0,0,0,2.943-.418,3.529,3.529,0,0,0,.9-.582,1.585,1.585,0,0,1,2.075.045,1.515,1.515,0,0,1-.137,2.127,5.72,5.72,0,0,1-2.459,1.311,10.1,10.1,0,0,1-5.863.067,7.427,7.427,0,0,1-4.54-3.908A9.585,9.585,0,0,1,830.363,472.059Z",
    transform: "translate(-613.826 -424.711)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M301.476,414.02h-1.651a1.53,1.53,0,0,1-1.268-.529,1.417,1.417,0,0,1-.242-1.487,1.3,1.3,0,0,1,1.11-.875,11.145,11.145,0,0,1,1.138-.043c.284-.006.568,0,.891,0,.008-.132.02-.243.02-.353,0-.75-.011-1.5.012-2.251a1.578,1.578,0,0,1,3.155-.012c.027.792.008,1.585.011,2.378,0,.062.006.125.011.223.117.005.228.014.339.014.718,0,1.437,0,2.155,0a1.483,1.483,0,0,1,1.356,2.219,1.55,1.55,0,0,1-1.46.717h-2.386c-.006.138-.021,6.263-.008,9.223a2.727,2.727,0,0,0,.171,1.019,1.381,1.381,0,0,0,1.721.6,3.463,3.463,0,0,1,.673-.154.957.957,0,0,1,.986.592,1.39,1.39,0,0,1-.454,1.774,3.836,3.836,0,0,1-2.843.584,6.046,6.046,0,0,1-1.265-.258,3.054,3.054,0,0,1-2.081-2.667,10.77,10.77,0,0,1-.087-1.548C301.472,420.28,301.476,417.373,301.476,414.02Z",
    transform: "translate(-115.403 -372.041)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M523.362,466.492c.112-.182.217-.369.336-.546a5.758,5.758,0,0,1,4.767-2.676,2.216,2.216,0,0,1,1.829.7,1.632,1.632,0,0,1,.079,1.862,1.514,1.514,0,0,1-1.775.535,3.884,3.884,0,0,0-1.537-.3,3.735,3.735,0,0,0-2.827,1.806,5.88,5.88,0,0,0-.939,3.443c0,2.418,0,4.837.005,7.255a1.7,1.7,0,0,1-.67,1.517,1.573,1.573,0,0,1-2.463-.948,2.526,2.526,0,0,1-.048-.5q0-6.624,0-13.249a1.587,1.587,0,0,1,3.158-.315c.029.466.005.935.005,1.4Z",
    transform: "translate(-323.248 -424.707)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M731.163,482.435a1.612,1.612,0,0,1-.833,1.58,1.589,1.589,0,0,1-2.335-1.318c-.019-.43-.006-13.658-.006-13.658a1.566,1.566,0,0,1,1.318-1.669,1.518,1.518,0,0,1,1.839,1.471C731.168,471.089,731.154,480.216,731.163,482.435Z",
    transform: "translate(-517.936 -428.525)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 2.829,
    cy: 2.816,
    rx: 2.829,
    ry: 2.816,
    transform: "translate(208.885 32)",
    fill: "#56b9be"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogostric);
export default __webpack_public_path__ + "static/media/logostric.d9967f60f3556d0bf66e473b9cf39e2d.svg";
export { ForwardRef as ReactComponent };